import { createTheme, globalTheme } from '@clds/component-theme';
export const checkboxTheme = createTheme({
    width: '0.875rem',
    height: '0.875rem',
    focus: {
        boxShadow: {
            sizes: '0 0 0 3px',
            color: globalTheme.palette.primary,
        },
    },
    border: {
        radius: globalTheme.radius.md,
        color: {
            inactive: globalTheme.palette.secondaryAlt,
            checked: globalTheme.palette.primary,
            disabled: globalTheme.palette.secondary,
            error: globalTheme.palette.error,
            hover: globalTheme.palette.primary,
        },
    },
    background: {
        color: {
            inactive: globalTheme.palette.surfaceAlt,
            checked: globalTheme.palette.primary,
            disabled: globalTheme.palette.secondary,
            error: globalTheme.palette.error,
        },
    },
    icon: {
        padding: '2px 1px',
        color: {
            inactive: globalTheme.palette.surfaceAlt,
            checked: globalTheme.palette.surfaceAlt,
            disabled: globalTheme.palette.secondaryAlt,
            error: globalTheme.palette.surfaceAlt,
        },
    },
}, 'checkbox');
//# sourceMappingURL=theme.js.map